import React, { createContext, useContext, useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

// Create Context
const TabVisibilityContext = createContext();

// Provider Component
export const TabVisibilityProvider = ({ children }) => {
  const [isVisible, setIsVisible] = useState(true);
  const location = useLocation();

  // Effect to hide or show tabs based on location
  useEffect(() => {
    if (
      location.pathname === "/subscription" ||
      location.pathname === "/myStore" ||
      location.pathname === "/" ||
      location.pathname === "/payments" ||
      location.pathname === "/activity" ||
      location.pathname === "/address"
    ) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  }, [location.pathname]);

  const hideTabs = () => setIsVisible(false);
  const showTabs = () => setIsVisible(true);

  return (
    <TabVisibilityContext.Provider value={{ isVisible, hideTabs, showTabs }}>
      {children}
    </TabVisibilityContext.Provider>
  );
};

// Custom Hook to Use the Context
export const useTabVisibility = () => useContext(TabVisibilityContext);
